import { AppWidgetState, DashboardPreference, FilterPreference, WidgetPosition } from '@ddv/models';

import { DashboardQueryParams } from './dashboard-query-params';
import { UpdateDashboardRequest } from './dashboard-requests';

export class WidgetFiltersAndLocationOnBoard {
    widgetOnBoardId = 0;
    widgetId = 0;
    width = 0;
    height = 0;
    left = 0;
    top = 0;
    maximized = false;
    widgetPosition: WidgetPosition | undefined;
    filters: string | undefined;

    constructor(widget?: AppWidgetState) {
        if (!widget) {
            return;
        }

        this.widgetOnBoardId = widget.id ?? this.widgetOnBoardId;
        this.widgetId = widget.coreWidgetId ?? this.widgetId;
        this.width = widget.width ?? this.width;
        this.height = widget.height ?? this.height;
        this.left = widget.left ?? this.left;
        this.top = widget.top ?? this.top;
        this.maximized = false;
        this.widgetPosition = widget.widgetPosition;
        this.filters = widget.widgetFilters ? JSON.stringify(this.fromIFilterPreference(widget.widgetFilters)) : undefined;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fromIFilterPreference(widgetFilters: FilterPreference): any {
        return {
            funds: widgetFilters.funds?.map((f) => ({ fundId: f.fundId })),
            clients: widgetFilters.clients,
            startDate: widgetFilters.startDate,
            endDate: widgetFilters.endDate,
            activeDate: widgetFilters.activeDate,
            filters: widgetFilters.filters,
        };
    }
}

export function getUpdateDashboardRequest(
    queryParams: DashboardPreference,
    widgets: AppWidgetState[],
    version: number,
): UpdateDashboardRequest {
    return {
        queryParams: mapDashboardPreferenceToQueryParams(queryParams),
        widgetFiltersAndLocationOnBoard: widgets.map((widget) => new WidgetFiltersAndLocationOnBoard(widget)),
        version,
    };
}

function mapDashboardPreferenceToQueryParams(dashboardPreference: DashboardPreference): DashboardQueryParams {
    return {
        funds: dashboardPreference.funds?.map((f) => ({ fundId: f.fundId, fundName: f.fundName })) ?? [],
        clients: dashboardPreference.clients ?? [],
        filters: dashboardPreference.filters ?? [],
        startDate: dashboardPreference.startDate ?? '',
        endDate: dashboardPreference.endDate ?? '',
        activeDate: dashboardPreference.activeDate ?? null,
    };
}
